import * as Types from '../../../../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type UpsertCourtCaseMessageMutationVariables = Types.Exact<{
  input: Types.CourtCaseMessageInput
}>

export type UpsertCourtCaseMessageMutation = {
  __typename?: 'Mutation'
  upsertCourtCaseMessage: {
    __typename?: 'Message'
    id: number
    content?: string | null
    topicQuestionnaireAnswers?: any | null
  }
}

export const UpsertCourtCaseMessageDocument = gql`
  mutation UpsertCourtCaseMessage($input: CourtCaseMessageInput!) {
    upsertCourtCaseMessage(input: $input) {
      id
      content
      topicQuestionnaireAnswers
    }
  }
`
export type UpsertCourtCaseMessageMutationFn = ApolloReactCommon.MutationFunction<
  UpsertCourtCaseMessageMutation,
  UpsertCourtCaseMessageMutationVariables
>
export function useUpsertCourtCaseMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertCourtCaseMessageMutation,
    UpsertCourtCaseMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpsertCourtCaseMessageMutation,
    UpsertCourtCaseMessageMutationVariables
  >(UpsertCourtCaseMessageDocument, options)
}
export type UpsertCourtCaseMessageMutationHookResult = ReturnType<
  typeof useUpsertCourtCaseMessageMutation
>
export type UpsertCourtCaseMessageMutationResult =
  ApolloReactCommon.MutationResult<UpsertCourtCaseMessageMutation>
export type UpsertCourtCaseMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpsertCourtCaseMessageMutation,
  UpsertCourtCaseMessageMutationVariables
>
